/**
 * @generated SignedSource<<66fe1368edc3770a9b46559dbcb854d2>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type IssueBodyViewerSubIssues$data = {
  readonly subIssues: {
    readonly totalCount: number;
  };
  readonly " $fragmentSpreads": FragmentRefs<"AddSubIssueButtonGroup">;
  readonly " $fragmentType": "IssueBodyViewerSubIssues";
};
export type IssueBodyViewerSubIssues$key = {
  readonly " $data"?: IssueBodyViewerSubIssues$data;
  readonly " $fragmentSpreads": FragmentRefs<"IssueBodyViewerSubIssues">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "IssueBodyViewerSubIssues",
  "selections": [
    {
      "alias": null,
      "args": [
        {
          "kind": "Literal",
          "name": "first",
          "value": 50
        }
      ],
      "concreteType": "IssueConnection",
      "kind": "LinkedField",
      "name": "subIssues",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "totalCount",
          "storageKey": null
        }
      ],
      "storageKey": "subIssues(first:50)"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "AddSubIssueButtonGroup"
    }
  ],
  "type": "Issue",
  "abstractKey": null
};

(node as any).hash = "bea353f64a316110114e5fa414c90531";

export default node;
